import React, { useContext } from 'react';
import { PriceCalculationContext } from '../PriceCalculationContext';

function Finished() {
    const { handleToSchoolSelection, continueShoppingUrl, resourcedTexts } =
        useContext(PriceCalculationContext);

    return (
        <div className="finished">
            <p>{resourcedTexts.finishedText}</p>
            <div className="finished__buttons">
                <button type="button" className="button secondary" onClick={handleToSchoolSelection}>
                    {resourcedTexts.selectOtherOrganizationButton}
                </button>
                <a href={continueShoppingUrl} className="button secondary">
                    {resourcedTexts.continueShopping}
                </a>
            </div>
        </div>
    );
}

export { Finished };
